/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_UnreachableInputs */



/**
* | output |
* | --- |
* | "The endpoint could not be reached. Check the URL and that it is reachable over HTTPS." |
*
* @param {Private_Models_Hint_UnreachableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_unreachable = /** @type {((inputs?: Private_Models_Hint_UnreachableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_UnreachableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Endpunkt war nicht erreichbar. Prüfen Sie die URL und ob sie per HTTPS erreichbar ist.")
	return /** @type {LocalizedString} */ ("The endpoint could not be reached. Check the URL and that it is reachable over HTTPS.")
});